<template>
  <v-dialog
    v-if="showDialog"
    :model-value="duplicateDialog"
    max-width="400"
    @click:outside="cleanUpAndCloseDialog"
  >
    <v-card>
      <v-card-title class="pt-4">Duplicate schematisation</v-card-title>
      <v-card-text class="pl-4 pt-0">
        <v-text-field
          prepend-inner-icon="mdi-content-duplicate"
          :model-value="schematisationToDuplicate.name"
          readonly
          color="primary"
          filled
        />
        <FormRHDHV ref="form" :form-order="order" :url="url" :model="model" />
        <v-select
          v-model="soilTypeRevision"
          prepend-inner-icon="mdi-landslide"
          :items="getRevisionSet(REVISION_KEY.SOIL_TYPE)"
          class="mt-4"
          label="Select soil type revision"
          return-object
          color="primary"
          @click.stop
          hide-details
          item-title="name"
          filled
          item-text="id"
        />
        <v-select
          v-model="waterLineRuleRevision"
          prepend-inner-icon="mdi-window-shutter-cog"
          :items="getRevisionSet(REVISION_KEY.WATER_LINE_RULE)"
          class="mt-4"
          label="Select water line rule revision"
          return-object
          color="primary"
          @click.stop
          hide-details
          item-title="name"
          filled
          item-text="id"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          :loading="duplicateLoading"
          color="primary"
          text
          :disabled="!model.name || duplicateLoading"
          @click="onDuplicateSchematisation"
        >
          Duplicate
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import FormRHDHV from '@/components/form/FormRHDHV.vue'
import { REVISION_KEY } from '@/components/constant'

export default {
  name: 'SchematisationDuplicateDialog',
  components: { FormRHDHV },
  data: () => ({
    url: 'stab_schematisations',
    model: { name: '' },
    order: ['name'],
    soilTypeRevision: null,
    waterLineRuleRevision: null
  }),
  computed: {
    ...mapState('project', {
      currentProject: (state) => state.currentProject
    }),
    ...mapState('stabSchematisation', {
      duplicateDialog: (state) => state.duplicateDialog,
      schematisationToDuplicate: (state) => state.currentOverviewItem,
      duplicateLoading: (state) => state.duplicateLoading
    }),
    ...mapGetters('project', {
      parameterSetName: 'parameterSetName',
      selectedRevision: 'selectedRevision'
    }),
    REVISION_KEY() {
      return REVISION_KEY
    },
    showDialog() {
      return this.schematisationToDuplicate?.id > 0
    }
  },
  watch: {
    duplicateDialog() {
      this.$refs.form?.resetValidation()
      if (this.duplicateDialog && this.schematisationToDuplicate) {
        this.soilTypeRevision = this.schematisationToDuplicate.soil_type_revision
        this.waterLineRuleRevision = this.schematisationToDuplicate.water_line_rule_revision
      }
    }
  },
  methods: {
    ...mapActions('stabSchematisation', {
      toggleDuplicateDialog: 'toggleDuplicateDialog',
      duplicate: 'duplicate'
    }),
    getRevisionSet(parameter) {
      const parameterSetName = this.parameterSetName(parameter)
      return this.currentProject[parameterSetName]
    },
    async onDuplicateSchematisation() {
      try {
        await this.duplicate({
          schematisation: this.schematisationToDuplicate.id,
          name: this.model.name,
          soil_type_revision: this.soilTypeRevision?.id,
          water_line_rule_revision: this.waterLineRuleRevision?.id
        })
      } catch (e) {
        console.log(e)
      } finally {
        this.cleanUpAndCloseDialog()
      }
    },
    cleanUpAndCloseDialog() {
      this.$refs.form.resetValidation()
      this.toggleDuplicateDialog()
      this.$refs.form.clearModel()
    }
  },
  async mounted() {
    this.soilTypeRevision = this.selectedRevision(REVISION_KEY.SOIL_TYPE)
    this.waterLineRuleRevision = this.selectedRevision(REVISION_KEY.WATER_LINE_RULE)
  }
}
</script>
